import { customAxios,  STOCK_URL } from '../constants';

export default function(codAreaVta) {

const data ={
    codAreaVta: codAreaVta,
    tipoEquipo: 1
}

  return customAxios.post(`${STOCK_URL}/equipo/tiposListar`, data,{});
}


// WEBPACK FOOTER //
// ./src/utils/getTipoEquipos.js